module.exports = __webpack_public_path__ + "img/icon37.6f625846.png";